import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import parseAmount from '../lib/parseAmount';
import { get } from 'lodash';
import styles from './donation-box.less';
import {
  Button,
  Checkbox,
  Text,
  SingleSelectionGroup,
  TextInput,
} from 'pp-react';

import * as analytics from '../lib/analytics';

import content from '../lib/i18n';
const i18n = content('app/components/donationBox');

export class DonationBox extends Component {
  constructor(props) {
    super(props);

    let nonanonymous = true;
    if (get(this.props, 'charityDetails.address.country_code') === 'GB') {
      nonanonymous = false;
    }

    this.state = {
      isInvalid: false,
      selectedAmount: '',
      inputAmount: '',
      errorPopup: false,
      clickedIndex: -1,
      radioBtnClicked: false,
      nonanonymous,
      clickedBackBtn: false,
    };

    this.invalid = this.invalid.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputFocus = this.handleInputFocus.bind(this);
    this.handleDonateClick = this.handleDonateClick.bind(this);
    this.handleNonAnonymousCheck = this.handleNonAnonymousCheck.bind(this);
  }

  invalid() {
    this.setState({
      isInvalid: true,
    });

    setTimeout(() => {
      this.setState({
        isInvalid: false,
      });
    }, 2000);
  }

  handleInputFocus() {
    this.setState({
      clickedIndex: -1,
      selectedAmount: '',
    });
  }

  handleDonateClick(event) {
    if (
      this.state.inputAmount === '' &&
      (!this.state.radioBtnClicked || this.state.selectedAmount === '')
    ) {
      event.preventDefault();
      this.invalid();
      this.setState({
        errorPopup: true,
      });
      setTimeout(() => {
        this.setState({
          errorPopup: false,
        });
      }, 2000);
    } else {
      let amount;
      if (this.state.inputAmount !== '') {
        amount = this.state.inputAmount;
      } else {
        amount = this.state.selectedAmount;
      }
      const flag = this.props.source ? `-${this.props.source}` : '';
      analytics.trackLinkWithData(
        `donatebutton${flag}`,
        this.props.fptiInfo.pgrp,
        this.props.fptiInfo.page,
        { amt: amount, nonanonymous: this.state.nonanonymous },
        'link'
      );
    }
  }

  componentDidUpdate() {
    /* Getting props from parent when back link is clicked , adding a new state clickedBackBtn to avoid infine looping */
    if (!this.props.clickedRadioBtn && !this.state.clickedBackBtn) {
      this.setState({
        clickedIndex: -1,
        clickedBackBtn: true, // back link clicked so set it true
      });
    }
  }

  handleInputChange(event) {
    const value = event.target.value;
    let input = parseAmount(value);
    if (input === undefined) {
      return this.invalid();
    }

    this.setState({
      inputAmount: input,
    });
  }

  handleNonAnonymousCheck(event) {
    this.setState(
      Object.assign({}, this.state, {
        nonanonymous: event.target.checked,
      })
    );
  }

  handleAmountSelection(event, index) {
    this.setState({
      selectedAmount: event.target.value,
      clickedIndex: index,
      radioBtnClicked: true,
      inputAmount: '',
      clickedBackBtn: false, // back link to be set to false again when page with radio buttons clicked
    });
  }

  renderForm() {
    const npid = this.props.charityDetails.nonprofit_id;
    const formUrl = `${this.props.coBrand}charity/${npid}/xo/create`;

    let name;
    if (this.props.charityDetails.charity_type !== 'PPGF_DIRECT') {
      name = i18n('label.ppgf-donation-description', {
        charity: this.props.charityDetails.name,
      });
    } else {
      name = i18n('label.donation-description', {
        charity: this.props.charityDetails.name,
      });
    }

    const donateText = this.props.donateButtonText
      ? this.props.donateButtonText
      : i18n('label.donate-button');
    return (
      <form
        style={{ display: 'inline-block', marginTop: '10px' }}
        method={'POST'}
        action={formUrl}
      >
        <input
          type={'hidden'}
          name={'_csrf'}
          value={this.props.csrf || this.context.csrf}
        />
        <input type={'hidden'} name={'npid'} value={npid} />
        <input
          type={'hidden'}
          name={'nonanonymous'}
          value={this.state.nonanonymous}
        />
        <input type={'hidden'} name={'source'} value={this.props.source} />
        <input type={'hidden'} name={'name'} value={name} />
        <input
          type={'hidden'}
          name={'currency'}
          value={this.props.amounts.currencyCode}
        />
        <input
          type={'hidden'}
          name={'amount'}
          value={
            this.state.selectedAmount
              ? this.state.selectedAmount
              : this.state.inputAmount
          }
        />
        {this.props.campaignState === 'ACTIVE' && (
          <Button
            id={'donateButtonCampaign'}
            className={styles['donateButton']}
            type={'submit'}
            onClick={this.handleDonateClick}
          >
            {donateText}
          </Button>
        )}
        {this.props.campaignState !== 'ACTIVE' && (
          <Button
            disabled
            id={'donateButtonCampaign'}
            className={styles['donateButton']}
            type={'submit'}
            onClick={this.handleDonateClick}
          >
            {donateText}
          </Button>
        )}
      </form>
    );
  }

  renderAmountOptions() {
    const inputBoxStyling = classNames(styles['textInputMargin'], {
      showError: this.state.errorPopup,
    });

    const placeholder = `${i18n('label.other-amount')} (${
      this.props.amounts.currencyCode
    })`;

    return (
      <div className={'donateButtonsDiv'}>
        <SingleSelectionGroup
          name='rating'
          value={this.state.selectedAmount}
          align='justify'
          onChange={e => this.handleAmountSelection(e)}
          options={this.props.amounts.options.map((option, index) => {
            return {
              label: option.formatted,
              value: option.value,
            };
          })}
          onBlue={e => {
            this.setState({
              selectedAmount: '',
            });
          }}
          data-nemo='amounts-selection-group'
        />
        <TextInput
          name='help'
          type={'text'}
          id={'amtInputField'}
          errorText={this.state.errorPopup && i18n('label.inputError')}
          helperText={this.state.isInvalid && i18n('label.invalidInput')}
          className={`${inputBoxStyling}`}
          onChange={this.handleInputChange}
          onFocus={this.handleInputFocus}
          value={this.state.inputAmount}
          label={placeholder}
          required
        />
      </div>
    );
  }

  renderAnonymousInput() {
    const charity = this.props.charityDetails;
    if (charity.charity_type !== 'PPGF_DIRECT') {
      return (
        <Checkbox
          label={i18n('label.non-anonymous')}
          name='non-anonymous'
          id={'non-anonymous-checkbox'}
          checked={this.state.nonanonymous}
          onClick={this.handleNonAnonymousCheck}
        />
      );
    }
  }

  render() {
    const donationAmountClass = classNames('alignStyle slideInRight hasError', {
      hide: !this.props.selectedCharity,
    });

    return (
      <div>
        <div className={donationAmountClass}>
          {this.renderAmountOptions()}
          {this.renderAnonymousInput()}
          {this.renderForm()}
        </div>
      </div>
    );
  }
}

DonationBox.propTypes = {
  amounts: PropTypes.object,
  csrf: PropTypes.string,
  charity: PropTypes.object,
};

export default DonationBox;
